/**
 * This file was auto-generated by Fern from our API Definition.
 */

/**
 * GREATER_THAN operator looks for values that are greater than the given value.
 */
export interface GreaterThanVersion {
    /** The value to compare against. */
    value: number;
}
